<template>
  <li class="flex gap-16">
    <div class="shrink-0 w-16 -mt-4">
      <IconCheckSmall />
    </div>

    <div class="body-2 block space-y-6">
      <slot />

      <template v-if="!!slots.appendix">
        <RevLink
          class="caption-link flex items-center"
          @click="showMore = !showMore"
        >
          <div>
            <template v-if="showMore">
              {{ showLessLabel || i18n(translations.showLessLabel) }}
            </template>
            <template v-else>
              {{ showMoreLabel || i18n(translations.showMoreLabel) }}
            </template>
          </div>

          <IconChevronUp v-if="showMore" />
          <IconChevronDown v-if="!showMore" />
        </RevLink>

        <div v-if="showMore" class="caption">
          <slot name="appendix" />
        </div>
      </template>
    </div>
  </li>
</template>

<script lang="ts" setup>
import { ref, useSlots } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import { IconCheckSmall } from '@ds/icons/IconCheckSmall'
import { IconChevronDown } from '@ds/icons/IconChevronDown'
import { IconChevronUp } from '@ds/icons/IconChevronUp'

import translations from './Benefit.translations'

const i18n = useI18n()
const showMore = ref(false)
const slots = useSlots()

defineProps<{
  showMoreLabel?: string
  showLessLabel?: string
}>()
</script>
